import invariant from 'tiny-invariant'
import { IScore } from 'models/score.model'
import Services from 'services'
import { TGlobalStore } from '..'
import type { StoreApi } from 'zustand'

export interface IUserScoreState {
  userScore: IScore | null
  fetchUserScore: () => Promise<void>
}

const userScoreSlice = (
  set: StoreApi<TGlobalStore>['setState'],
  get: StoreApi<TGlobalStore>['getState'],
): IUserScoreState => ({
  userScore: null,
  fetchUserScore: async () => {
    try {
      const { user } = get()
      invariant(user, 'Expected value to be a user')
      const userScore = await Services.Score.getScoreV2()
      set(state => ({ ...state, userScore }))
    } catch {
      set(state => ({ ...state, userScore: null }))
    }
  },
})

export default userScoreSlice
